<div *ngIf="!emptyTask && !!task" class="card mt-2 cursor">
    <div [routerLink]="['/view-task/'+ task._id]" class="card-body">
        <p class="card-text">
            <span [ngClass]="{'task-completed': (task.status =='ddone' || task.status =='validated'),
             'task-not-completed': (task.status !=='ddone' && task.status !=='validated') }"><i
                    class="fa fa-check"></i></span>

            {{task.title}}</p>
        <div class="col-12 no-padding text-left">
            <div *ngIf="previewAvatars" class="col-12 pl-2 pr-0">
                <app-avatar personalStyle="margin-left:5px" [assigned]="assign" *ngFor="let assign of assignedArray"
                            avatarWidth="25"></app-avatar>

                <div class="ml-4">
                <span *ngFor="let tag of task.tags" style="background-color: #007bff;
    font-size: 13px;
    border-radius: 10px;" class="badge badge-primary ml-1 mb-1">{{tag}}</span>
                    <span style="background-color: #87ceeb;
    font-size: 13px;
    border-radius: 10px;" class="badge badge-primary  ml-1 mb-1 text-uppercase"
                          *ngIf="task.tags.length ==0">nema tagova</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="emptyTask" class="card mt-2">
    <div class="card-body">
        <p class="card-text">
            <span><i
                    class="fa fa-info-circle"></i></span>

            Nema podzadataka.</p>
    </div>
</div>


